// extracted by mini-css-extract-plugin
export default {"images":"home_images__JOAew","content":"home_content__GVkv4","divIcons":"home_divIcons__Au9Mu","icon":"home_icon__j5V2y","Hello":"home_Hello__EU1ah"};